module.exports = __webpack_public_path__ + "assets/img/tentacle-attack.8f0a8854.png";